import { render, staticRenderFns } from "./config-properties.vue?vue&type=template&id=344defac&scoped=true&"
import script from "./config-properties.vue?vue&type=script&lang=js&"
export * from "./config-properties.vue?vue&type=script&lang=js&"
import style0 from "./config-properties.vue?vue&type=style&index=0&id=344defac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344defac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('344defac')) {
      api.createRecord('344defac', component.options)
    } else {
      api.reload('344defac', component.options)
    }
    module.hot.accept("./config-properties.vue?vue&type=template&id=344defac&scoped=true&", function () {
      api.rerender('344defac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/Selected-products/modules/config-properties.vue"
export default component.exports